import React from 'react';
import {Container, Row, Col, Navbar, Nav, NavDropdown} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import '../styles/components/navigationbar.css'

export const NavigationBar = () => {
    return (
      <>
      <Container fluid className="d-none d-md-block" style={{backgroundColor: 'var(--blue)'}}>
        <Container className="fablab-prenavbar">
          <Row>
            <Col>
              <a className="white" href ="https://www.usm.cl/" target="_blank" rel="noreferrer">USM.cl</a>
              <span className="white ml-2"> &gt; </span>
              <a className="white" href ="http://fablab.usm.cl/">FabLab UTFSM</a>
            </Col>
          </Row>
        </Container>
      </Container>

      <Navbar expand="lg">
        <Container>
          <Navbar.Brand href="/"><img src='./assets/images/logo-usm.svg' alt='Logo UTFSM'/></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {/* <Nav.Link href="conocenos#mision-y-vision">Misión y Visión</Nav.Link> */}
              <Nav.Link href="conocenos#indicadores">Indicadores</Nav.Link>
              <NavDropdown title="Nosotros" id="basic-nav-dropdown-nosotros">
                <NavDropdown.Item href="conocenos#historia">Historia</NavDropdown.Item>
                <NavDropdown.Item href="conocenos#equipo">Equipo</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Laboratorio" id="basic-nav-dropdown-laboratorio">
                <NavDropdown.Item href="conocenos#maquinas">Máquinas</NavDropdown.Item>
                <NavDropdown.Item href="conocenos#tour-virtual">Tour Virtual</NavDropdown.Item>
                <NavDropdown.Item href="conocenos#ubicacion">Ubicación</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="conocenos#contacto">Contacto</Nav.Link>
              <Nav.Link href="/inscribir-proyecto">Inscribir proyecto</Nav.Link>
              {/* <Nav.Link href="">Portal <FontAwesomeIcon icon={faSignOutAlt}></FontAwesomeIcon></Nav.Link> */}
              <Nav.Link href="/classroom">Classroom <FontAwesomeIcon icon={faSignOutAlt}></FontAwesomeIcon></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      </>
    )
}
